import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const LangCtx = createContext(null);

const CACHE_KEY = "falzilla_lang";
const CACHE_DATA = "falzilla_i18n";

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(CACHE_KEY) || "tr");
  const [dict, setDict] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CACHE_DATA) || "{}"); } catch { return {}; }
  });
  const [languages, setLanguages] = useState([{ code: "tr", name: "Türkçe" }, { code: "en", name: "English" }]);

  const load = useCallback(async (code) => {
    try {
      const { data } = await api.get(`/i18n/${code}`);
      setDict(data);
      localStorage.setItem(CACHE_DATA, JSON.stringify(data));
    } catch (e) {
      // silent
    }
  }, []);

  useEffect(() => {
    api.get("/i18n/languages").then(({ data }) => setLanguages(data)).catch(() => {});
    load(lang);
  }, [lang, load]);

  const changeLang = (code) => {
    localStorage.setItem(CACHE_KEY, code);
    localStorage.setItem("falzilla_lang", code);
    setLang(code);
  };

  const t = useCallback((key, params) => {
    let val = dict[key] || key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        val = val.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
      }
    }
    return val;
  }, [dict]);

  return (
    <LangCtx.Provider value={{ lang, changeLang, t, languages }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx) || { lang: "tr", t: (k) => k, changeLang: () => {}, languages: [] };
